import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Row,
  Col,
  Button,
  Table,
  Input,
  Select,
  Popover,
  Pagination,
  DatePicker,
  Tag,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
const { RangePicker } = DatePicker;

const TablaAcuerdosExtrajudiciales = ({
  history,
  usuario,
  acuerdosExtrajudiciales,
  total,
  cambiarPagina,
  tamPagina,
  cambiarTamañoPagina,
  loadingTabla,
  pagina,
  filtroEstadoPadre,
  setFiltrarEstado,
  filtroNumeroPadre,
  setFiltrarNumero,
  filtroNombrePadre,
  filtroApellidoPadre,
  setFiltrarPorAPyN,
  onChangeRangoFechas,
  rangoFechas,
  descargarReporte,
  onDeleteAcuerdo,
}) => {
  // ESTADOS ==>
  const [disableReporte, setDisableReporte] = useState(true);
  const [filtroEstado, setFiltroEstado] = useState(filtroEstadoPadre);
  const [filtroNumero, setFiltroNumero] = useState(filtroNumeroPadre);
  const [filtroAPyN, setFiltroAPyN] = useState({
    nombre: filtroNombrePadre,
    apellido: filtroApellidoPadre,
  });

  useEffect(() => {
    if (rangoFechas.fechaInicial !== '' && rangoFechas.fechaFinal !== '') {
      setDisableReporte(acuerdosExtrajudiciales.length <= 0);
    } else {
      setDisableReporte(true);
    }
  }, [rangoFechas]);

  const setFiltroNombre = value => {
    setFiltroAPyN({ ...filtroAPyN, nombre: value });
  };

  const setFiltroApellido = value => {
    setFiltroAPyN({ ...filtroAPyN, apellido: value });
  };

  const columns = [
    {
      title: 'Fecha Carga',
      dataIndex: 'fechaCreacion',
      key: 'fechaCarga',
      width: 120,
      align: 'center',
      render: fecha => moment(fecha).format('DD-MM-YYYY'),
    },
    {
      title: 'N° Acuerdo',
      dataIndex: 'numero',
      key: 'numero',
      align: 'center',
      render: numero => (numero !== -1 ? numero : 'ERROR'),
      filterDropdown: (
        <div>
          <Input
            style={{ width: 120 }}
            placeholder="Buscar N°"
            value={filtroNumero}
            onChange={e => setFiltroNumero(e.target.value)}
            onPressEnter={() => setFiltrarNumero(filtroNumero)}
          />
          <Button
            icon={<Icons.SearchOutlined />}
            type="primary"
            onClick={() => setFiltrarNumero(filtroNumero)}
          />
          <Button
            icon={<Icons.CloseCircleOutlined />}
            type="danger"
            onClick={() => {
              setFiltrarNumero(null);
              setFiltroNumero(null);
            }}
          />
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroNumero ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Requirente',
      dataIndex: 'requirente',
      align: 'center',
      render: usuario =>
        usuario ? usuario.nombre + ' ' + usuario.apellido : '',
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Nombre:</p>
            </Col>
            <Col offset={2} span={16}>
              <Input
                value={filtroAPyN.nombre}
                style={{ margin: 10 }}
                placeholder="Nombre"
                onChange={e => setFiltroNombre(e.target.value)}
                onPressEnter={() =>
                  setFiltrarPorAPyN({
                    nombreRequirente: filtroAPyN.nombre,
                    apellidoRequirente: filtroAPyN.apellido,
                  })
                }
              />
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Apellido:</p>
            </Col>
            <Col offset={2} span={16}>
              <Input
                value={filtroAPyN.apellido}
                style={{ margin: 10 }}
                placeholder="Apellido"
                onChange={e => setFiltroApellido(e.target.value)}
                onPressEnter={() =>
                  setFiltrarPorAPyN({
                    nombreRequirente: filtroAPyN.nombre,
                    apellidoRequirente: filtroAPyN.apellido,
                  })
                }
              />
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '8px 8px' }}
                onClick={() =>
                  setFiltrarPorAPyN({
                    nombreRequirente: filtroAPyN.nombre,
                    apellidoRequirente: filtroAPyN.apellido,
                  })
                }
              />

              <Button
                icon={<Icons.CloseOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => {
                  setFiltroAPyN({
                    nombre: null,
                    apellido: null,
                  });
                  setFiltrarPorAPyN({
                    nombreRequirente: null,
                    apellidoRequirente: null,
                  });
                }}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{
            color:
              filtroAPyN.nombre || filtroAPyN.apellido ? '#1890ff' : undefined,
          }}
        />
      ),
    },
    {
      title: 'Cantidad Requeridos',
      dataIndex: 'requeridos',
      align: 'center',
      render: requeridos => (requeridos.length > 0 ? requeridos.length : 0),
    },

    {
      title: 'Estado',
      dataIndex: 'estado',
      width: 120,
      align: 'center',
      render: estado => {
        const estadoTags = {
          'EN TRAMITE': <Tag color="#108ee9">EN TRAMITE</Tag>,
          FINALIZADO: <Tag color="#f50">FINALIZADO</Tag>,
        };
        return estadoTags[estado] || '-';
      },
      filterDropdown: (
        <div>
          <Row>
            <Col span={4}>
              <p style={{ margin: 10 }}>Estado:</p>
            </Col>
            <Col span={16}>
              <Select
                style={{ width: 180, margin: '10px 18px' }}
                id="estados"
                placeholder="Seleccione el estado"
                onSelect={valor => setFiltroEstado(valor)}
                value={filtroEstado}
              >
                <Select.Option key={'EN TRAMITE'}>EN TRAMITE</Select.Option>
                <Select.Option key={'FINALIZADO'}>FINALIZADO</Select.Option>
              </Select>
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '7px 5px' }}
                onClick={() => {
                  setFiltrarEstado(filtroEstado);
                }}
              />
              <Button
                icon={<Icons.EditOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => {
                  setFiltrarEstado(null);
                  setFiltroEstado(null);
                }}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroEstado ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Acciones',
      align: 'center',
      render: (text, record) => (
        <span>
          <Button
            size="small"
            type="primary"
            icon={<Icons.CheckOutlined />}
            style={{ marginRight: 10 }}
            onClick={() =>
              history.push(
                `/tramites/acuerdosExtrajudiciales/${record._id}/ver`
              )
            }
          >
            Ver
          </Button>

          <Button
            size="small"
            icon={<Icons.DeleteOutlined />}
            type="danger"
            disabled={record.estado !== 'EN TRAMITE'}
            onClick={() => onDeleteAcuerdo(record._id)}
          >
            Eliminar
          </Button>
        </span>
      ),
    },
  ];

  const pagination = {
    onChange: page => {
      cambiarPagina(page);
    },
    total: total,
    current: pagina,
    pageSize: tamPagina ? tamPagina : null,
    showSizeChanger: true,
    onShowSizeChange: (current, pageSize) => {
      cambiarTamañoPagina(pageSize);
      cambiarPagina(1);
    },
  };

  return (
    <div>
      <Table
        rowKey="_id"
        columns={columns}
        pagination={pagination}
        dataSource={acuerdosExtrajudiciales}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}> Acuerdos Extrajudiciales </h2>
            <Row style={{ marginTop: 15 }}>
              <Col offset={6}>
                <Row>
                  <Col span={6}>
                    <h4>Rango de Fechas Carga: </h4>
                  </Col>
                  <Col span={16}>
                    <RangePicker
                      style={{ width: 350, marginLeft: 5 }}
                      onChange={onChangeRangoFechas}
                      format={'DD-MM-YYYY'}
                      defaultValue={[
                        rangoFechas.fechaInicial,
                        rangoFechas.fechaFinal,
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Button
                  style={{ marginLeft: 15 }}
                  type="primary"
                  disabled={disableReporte}
                  onClick={descargarReporte}
                >
                  <Icons.DownloadOutlined />
                  Descargar Reporte
                </Button>
              </Col>
            </Row>
          </div>
        )}
        locale={{
          emptyText: 'Sin Acuerdos.',
        }}
        loading={loadingTabla}
      />
    </div>
  );
};

export default TablaAcuerdosExtrajudiciales;
